import React, { useContext, useState, useEffect } from 'react';

import { useSelector } from 'react-redux';

import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';

import FilterCtx from '../../../../context/filterContext/filterCtx';
import { RootState } from '../../../../redux/store';

import '../../dropdown/dropdown.scss';
import '../filters.scss';
import './activityFeedPeriodFilter.scss';

const periodsStates = [
  { periodName: 'All', value: 0 },
  { periodName: 'Last 30 days', value: 30 },
  { periodName: 'Last 60 days', value: 60 },
  { periodName: 'Last 90 days', value: 90 },
];

const ActivityFeedPeriodFilter: React.FC = () => {
  const [value, setValue] = useState<number>(30);
  const [periods, setPeriods] = useState<any[]>(periodsStates);

  const filterCtx: any = useContext(FilterCtx);

  const impersonation = useSelector((state: RootState) => state.impersonate);

  const handlePeriodChange = (event: DropDownListChangeEvent): void => {
    setValue(event.value && event.value.value);
  };

  useEffect(() => {
    setPeriods(periodsStates);
    setValue(filterCtx.activityFeedFromDate);
  }, [impersonation]);

  useEffect(() => {
    filterCtx.setActivityFeedFromDate(value);
  }, [value]);

  return (
    <>
      <div className='activity-periods-filter-mobile-wrapper hidden-desktop'>
        <div className={`filter-btn ${filterCtx.activityFeedFromDate === 30 ? 'active' : ''}`}
             onClick={() => filterCtx.setActivityFeedFromDate(30)}>{periodsStates[1].periodName}</div>
        <div className={`filter-btn ${filterCtx.activityFeedFromDate === 60 ? 'active' : ''}`}
             onClick={() => filterCtx.setActivityFeedFromDate(60)}>{periodsStates[2].periodName}</div>
        <div className={`filter-btn ${filterCtx.activityFeedFromDate === 90 ? 'active' : ''}`}
             onClick={() => filterCtx.setActivityFeedFromDate(90)}>{periodsStates[3].periodName}</div>
        <div className={`filter-btn ${filterCtx.activityFeedFromDate === 0 ? 'active' : ''}`}
             onClick={() => filterCtx.setActivityFeedFromDate(0)}>{periodsStates[0].periodName}</div>
      </div>
      <div className='activity-periods-filter-wrapper hidden-mobile'>
        <DropDownList
          className='custom-dropdown-style filters-dropdown'
          data={periods}
          defaultValue={
            value === 0
              ? periodsStates[0]
              : value === 30
                ? periodsStates[1]
                : value === 60
                  ? periodsStates[2]
                  : value === 90
                    ? periodsStates[3]
                    : periodsStates[0]
          }
          textField='periodName'
          dataItemKey='value'
          onChange={handlePeriodChange}
        />
      </div>
    </>
  );
};

export default ActivityFeedPeriodFilter;
